'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _AnchorButton = require('../../../components/buttons/AnchorButton');

var _AnchorButton2 = _interopRequireDefault(_AnchorButton);

var _MilanoteLogotype = require('../../../components/icons/MilanoteLogotype');

var _MilanoteLogotype2 = _interopRequireDefault(_MilanoteLogotype);

var _urlConstants = require('../../../../common/utils/urlConstants');

require('./RegisterHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterHeader = function RegisterHeader(props) {
    return _react2.default.createElement(
        'header',
        { className: 'RegisterHeader' },
        _react2.default.createElement(
            'nav',
            null,
            _react2.default.createElement(
                _AnchorButton2.default,
                { href: _urlConstants.MARKETING_URL },
                _react2.default.createElement(_MilanoteLogotype2.default, null)
            ),
            _react2.default.createElement(
                'div',
                { className: 'nav-right' },
                _react2.default.createElement(
                    _AnchorButton2.default,
                    { href: _urlConstants.MARKETING_PLANS_URL, className: 'plans-button' },
                    'View plans'
                ),
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/login', className: 'login-button' },
                    'Log in'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'title-section' },
            _react2.default.createElement(
                'h1',
                null,
                'The notes app for creative work'
            ),
            _react2.default.createElement(
                'p',
                null,
                'For the research, thinking and planning behind your next great piece of work.'
            )
        )
    );
};

exports.default = RegisterHeader;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/register/RegisterHeader.js
// module id = 1685
// module chunks = 0